import { memo, useCallback, useContext, useMemo } from 'react';
import { Switch } from 'antd';
import { SkippedContext } from './SkippedContext';

interface ToggleFilterProps {
  name: string;
}

export const ToggleFilter = memo(({ name }: ToggleFilterProps) => {
  const [skipped, setSkipped] = useContext(SkippedContext);
  const isSkipped = useMemo(() => skipped[name], [name, skipped]);
  const handleChange = useCallback(
    (value: boolean) => {
      setSkipped((state) => {
        const nextState = { ...state };
        nextState[name] = !value;
        return nextState;
      });
    },
    [setSkipped, name],
  );
  return <Switch checked={!isSkipped} onChange={handleChange} />;
});
